import { TFunction } from 'i18next'

import { RecurringInvoice } from '@features/recurringInvoices/types/recurringInvoice'

import { RecurringInvoicesTableAccessor } from '../../../enums/recurringInvoicesTableAccessor'
import { RecurringInvoicesTableRow } from '../../../types/recurringInvoicesTableRow'

export const getRecurringInvoicesTableData = (
  recurringInvoices: RecurringInvoice[],
  t: TFunction,
): RecurringInvoicesTableRow[] => {
  return recurringInvoices.map(({ createdAt, draft, id, lastInvoiceGeneratedDate, schedule, status }) => {
    return {
      [RecurringInvoicesTableAccessor.Status]: status.status,
      [RecurringInvoicesTableAccessor.Customer]: draft.customer.displayName,
      [RecurringInvoicesTableAccessor.Date]: createdAt,
      [RecurringInvoicesTableAccessor.FirstInvoice]: schedule.startDate,
      [RecurringInvoicesTableAccessor.Frequency]: schedule.frequency,
      [RecurringInvoicesTableAccessor.LastInvoice]: lastInvoiceGeneratedDate,
      [RecurringInvoicesTableAccessor.NextInvoice]: status.nextScheduleDate,
      [RecurringInvoicesTableAccessor.GrossTotal]: draft?.summary.foreignGrossTotal,
      currency: draft?.summary?.foreignCurrency,
      id: String(id),
    }
  })
}
